export default "__VITE_ASSET__M5_Qkx6A__"